export const UtilityClassSectionHeader = () => (
    <div className="sds_example__column-container">
        <div style={{ width: '30%' }} className="sds_example__column-header">
            Class Name
        </div>
        <div style={{ width: '70%' }} className="sds_example__column-header">
            Example
        </div>
    </div>
);
